module.exports = __webpack_public_path__ + "449b3b4b4cd88903df3a5e0c1c2b4349.jpg";